import {
  WhmDialog,
  WhmDialogTitle,
  WhmDialogContent,
  WhmDialogActions,
  WhmButton,
  WhmTypography,
  WhmBox,
  WhmIconButton,
} from "@securitize/reactjs-whm";
import closeIcon from "@securitize/assets-sec-ui/dist/icons/svg/exit.svg";

export interface FundDetailsModalProps {
  open: boolean;
  onClose: () => void;
  fundHoldingInfo: { title: string; value: string }[];
}

const DetailRow = ({ label, value }: { label: string; value: string }) => (
  <WhmBox sx={{ display: "flex", justifyContent: "space-between", p: "8px 0" }}>
    <WhmTypography variant="body1" color="text.secondary">
      {label}
    </WhmTypography>
    <WhmTypography
      variant="body1"
      color="text.primary"
      sx={{ lineHeight: "26px", textAlign: "right" }}
    >
      {value}
    </WhmTypography>
  </WhmBox>
);

export const FundDetailsModal = ({
  open,
  onClose,
  fundHoldingInfo,
}: FundDetailsModalProps) => {
  return (
    <WhmDialog open={open} onClose={onClose} fullScreen>
      {!!fundHoldingInfo && (
        <>
          <WhmDialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <WhmTypography variant="h4" color="text.primary">
              Security Details
            </WhmTypography>
            <WhmIconButton
              aria-label="close"
              onClick={onClose}
              sx={{ padding: "4px" }}
            >
              <img src={closeIcon} alt="close" />
            </WhmIconButton>
          </WhmDialogTitle>
          <WhmDialogContent>
            {fundHoldingInfo.map((detail) => (
              <DetailRow
                key={detail.title}
                label={detail.title}
                value={detail.value}
              />
            ))}
          </WhmDialogContent>
          <WhmDialogActions>
            <WhmButton
              onClick={onClose}
              variant="contained"
              size="medium"
              color="primary"
              fullWidth
              sx={{
                backgroundColor: (theme) =>
                  // eslint-disable-next-line max-len
                  `${theme.palette.primary.main} !important`, // workaround for the button color issue because of tailwindcss
              }}
            >
              Understood
            </WhmButton>
          </WhmDialogActions>
        </>
      )}
    </WhmDialog>
  );
};
